'use client';
import React, { Suspense } from 'react';
import LoginPage from './LoginContent';

export default function LoginPageWrapper() {
  return (
    <Suspense fallback={
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0f1f3d 0%, #1a3a6b 50%, #0f1f3d 100%)' }}>
        <div className="flex flex-col items-center gap-3">
          <div className="w-6 h-6 border-2 border-blue-300/40 border-t-blue-300 rounded-full animate-spin" />
          <p className="text-blue-200/60 text-sm">Preparing your workspace...</p>
        </div>
      </div>
    }>
      <LoginPage />
    </Suspense>
  );
}
